import { Box } from "@mui/material";

interface HotkeyProps {
  label: string;
  waitingForInput?: boolean;
  onClick?: () => void;
}

export const Hotkey = ({
  label,
  waitingForInput = false,
  onClick,
}: HotkeyProps) => {
  return (
    <Box
      component="kbd"
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "24px",
        height: "24px",
        px: 0.75,
        fontSize: "0.75rem",
        fontWeight: 600,
        fontFamily: "monospace",
        color: waitingForInput ? "primary.main" : "text.primary",
        backgroundColor: waitingForInput
          ? "action.selected"
          : "background.paper",
        border: "1px solid",
        borderColor: waitingForInput ? "primary.main" : "divider",
        borderRadius: 1,
        boxShadow: onClick ? "0 2px 0 0 rgba(0,0,0,0.08)" : "none",
        cursor: onClick ? "pointer" : "default",
        opacity: onClick ? 1 : 0.6,
        transition: "all 0.2s ease",
        ...(onClick && {
          "&:hover": {
            backgroundColor: "action.hover",
            borderColor: "primary.light",
          },
          "&:active": {
            boxShadow: "0 1px 0 0 rgba(0,0,0,0.08)",
            transform: "translateY(1px)",
          },
        }),
        ...(!onClick && {
          borderStyle: "dashed",
        }),
        ...(waitingForInput && {
          animation: "pulse 1.5s ease-in-out infinite",
          "@keyframes pulse": {
            "0%, 100%": { opacity: 1 },
            "50%": { opacity: 0.6 },
          },
        }),
      }}
    >
      {label}
    </Box>
  );
};
